import { render, staticRenderFns } from "./DevRequirementCard.vue?vue&type=template&id=27ef53ac&scoped=true"
import script from "./DevRequirementCard.vue?vue&type=script&lang=js"
export * from "./DevRequirementCard.vue?vue&type=script&lang=js"
import style0 from "./DevRequirementCard.vue?vue&type=style&index=0&id=27ef53ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef53ac",
  null
  
)

export default component.exports